import { ConversationsAction } from "./conversation-atom.reducer";
import { Dispatch } from "react";
import ToolCallInteractionService from "utilities/services/conversations/tool-call-interaction-service";
import { ToolCallStatusAction } from "models/enumerations/conversations/tool-call-interaction-action";

export interface UpdateToolCallStatusParams {
    messageId: string;
    toolCallId: string;
    status: ToolCallStatusAction;
}
export const updateToolCallStatus =
    (params: UpdateToolCallStatusParams) =>
    async (dispatch: Dispatch<ConversationsAction>) => {
        if (!params.toolCallId) {
            dispatch({
                type: "ERROR",
                error: new Error("ToolCall id is required"),
            });
            return;
        }

        try {
            await ToolCallInteractionService.create(
                {
                    action: params.status,
                },
                { toolCallId: params.toolCallId }
            );

            dispatch({
                type: "UPDATE_TOOL_CALL_STATUS",
                messageId: params.messageId,
                toolCallId: params.toolCallId,
                status: params.status,
            });
        } catch (error) {
            dispatch({
                type: "ERROR",
                error: new Error(`Failed to update tool call status: ${error}`),
            });
        }
    };
